import { useContext } from 'react';
import { SnackbarContext } from '../snackbar-context';

export const usePublishSnackbarNotification = () => {
    return useContext(SnackbarContext);
};

